import {call, put, takeLatest} from 'redux-saga/effects';
import {
  submitHelpRequestRequest,
  submitHelpRequestSuccess,
  submitHelpRequestFailure,
  getSupportTicketsRequest,
  getSupportTicketsSuccess,
  getSupportTicketsFailure,
  sendReplyRequest,
  sendReplySuccess,
  sendReplyFailure,
  markAsSpamRequest,
  markAsSpamSuccess,
  markAsSpamFailure,
 
} from '../slices/supportAdminSlice';

import {submitHelpRequest, getSupportTickets, sendReply, markAsSpam} from '@/services/api';
import {SUCCESS_KEY} from '@/constants';

function* submitHelpRequestSaga(action: any): Generator {
  try {
    const response: any = yield call(submitHelpRequest, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(submitHelpRequestSuccess(response.data));
    } else {
      yield put(submitHelpRequestFailure(response.data));
    }
  } catch (error: any) {
    yield put(submitHelpRequestFailure(error.response?.data || {status: 'error', status_code: 'E-10001'}));
  }
}


function* getSupportTicketsSaga(action: any): Generator {
  try {
    const response: any = yield call(getSupportTickets, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSupportTicketsSuccess(response.data));
    } else {
      yield put(getSupportTicketsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSupportTicketsFailure(error.response?.data || error.response));
  }
}

function* sendReplySaga(action: any): Generator {
  try {
    const response: any = yield call(sendReply, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(sendReplySuccess(response.data));
    } else {
      yield put(sendReplyFailure(response.data));
    }
  } catch (error: any) {
    yield put(sendReplyFailure(error.response?.data || error.response));
  }
}

function* markAsSpamSaga(action: any): Generator {
  try {
    const response: any = yield call(markAsSpam, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(markAsSpamSuccess(response.data));
    } else {
      yield put(markAsSpamFailure(response.data));
    }
  } catch (error: any) {
    yield put(markAsSpamFailure(error.response?.data || error.response));
  }
}

export default function* supportAdminSaga(): Generator {
  yield takeLatest(submitHelpRequestRequest.type, submitHelpRequestSaga);
  yield takeLatest(getSupportTicketsRequest.type, getSupportTicketsSaga);
  yield takeLatest(sendReplyRequest.type, sendReplySaga);
  yield takeLatest(markAsSpamRequest.type, markAsSpamSaga);
}





